const cleanMapboxBrand = () => {
  const brand = document.querySelector('.mapboxgl-ctrl-logo')
  if (brand) {
    brand.style.display = 'none';
  }
}

export { cleanMapboxBrand }
